import request from "@/plugins/axios"

let prefix = "eids-invoice/codeList";

export function findByCatalog(catalog) {
  return request({
    url: prefix + '/findByCatalog/' + catalog,
    method: 'get',
  })
}

// 获取codeList
export function getSelectOptions(catalog, headerText){
  let selectOptions = [{ text: headerText, value: "" }];

  findByCatalog(catalog)
    .then(res => {

      res.map(item => {
        let option1 = {};
        option1.text = item.name;
        option1.value = item.code;
        selectOptions.push(option1);
      });
    })
    .catch(err => {
      console.log("err", err);
    });
  
  return selectOptions;
}

